import { useEffect } from 'react'

import {getBookById, getUsersBookByBookId, getHomeStadistic, getBookMessageCountById} from '../../../services/sBook/book.service'
import { isNullUndefined, treeify } from '../../../common/Helpers';
import { getBookMemberRelationshipProps } from '../../../services/sPrivilege/privilege.service';
import { useDispatch } from 'react-redux';
import { action_setFireBook } from '../../../reducers/actions/Book/actions';

const useGetUsersByBookId = (bookId, bookUserList, setBookUserList, makeTreeObject, isPanelOpen, fireGetBookUsers) => {    
    useEffect(()=> {
        const getData = async () => {
            try {
                let serviceResponse = await getUsersBookByBookId(bookId);
                
                if (serviceResponse.data.succeeded) {
                    if (makeTreeObject !== undefined && makeTreeObject !== null) {
                        if (makeTreeObject) {
                            serviceResponse = treeify(serviceResponse !== null ? serviceResponse.data.data : [], 'id', null, 'children', null, "username");
                            setBookUserList(serviceResponse)
                        }
                        else {
                            setBookUserList(prevState => ({
                                ...prevState,
                                data: serviceResponse.data.data
                            }));
                        }
                    }
                    else {
                        setBookUserList(prevState => ({
                            ...prevState,
                            data: serviceResponse.data.data
                        }));
                    }
                }
                else {
                    if (makeTreeObject !== undefined && makeTreeObject !== null) {
                        if (makeTreeObject) {
                            setBookUserList([])
                        }
                        else {
                            setBookUserList(prevState => ({
                                ...prevState,
                                data: []
                            }));
                        }
                    }
                    else {
                        setBookUserList(prevState => ({
                            ...prevState,
                            data: []
                        }));
                    }
                }
            }
            catch (error) {
            }
        }
        
        if (bookId && isPanelOpen && fireGetBookUsers && (bookUserList === null || bookUserList.data === null)) {
            getData()
        }
    }, [bookId, bookUserList, setBookUserList, makeTreeObject, isPanelOpen, fireGetBookUsers]);
}

const useGetBookById = (qsBookId, bookId, setSuccessful, setMessage, setBookItem, setParentBookObject, fireGet, userProps) => {    
    const dispatch = useDispatch();
    
    useEffect(()=> {
        const getData = async () => {
            let objBookEmpty = {
                bookCode: " ",
                bookNemo: null,
                id: 0,
                name: "",
                requiresApproval: false,
                autoSignature: false,
                hasMilestone: false,
                mainBook: false,
                statusId: 0,
                messageCounts: 0
            }

            try {
                let serviceResponseBook = await getBookById(qsBookId);
                const responseBook = serviceResponseBook.data;

                if (responseBook.succeeded) {
                    dispatch(action_setFireBook(false))
                    objBookEmpty = responseBook.data;
                    
                    if (!isNullUndefined(userProps)) {
                        let serviceResponseMessageCount = await getBookMessageCountById(qsBookId, userProps.partyId, userProps.partyMemberId);
                        const responseMessageCount = serviceResponseMessageCount.data;
                        if (responseMessageCount.succeeded) {
                            objBookEmpty.messageCounts = responseMessageCount.data;
                        }
                        else {
                            objBookEmpty.messageCounts = 0;
                        }
                    }

                    setBookItem(objBookEmpty);
                    setParentBookObject && setParentBookObject(objBookEmpty)
                } else {
                    dispatch(action_setFireBook(false))
                    setBookItem(objBookEmpty)
                    setParentBookObject && setParentBookObject(objBookEmpty)
                    setMessage(responseBook.message);
                    setSuccessful(false);
                }

            }
            catch (error) {
                dispatch(action_setFireBook(false))
                setBookItem(objBookEmpty)
                setParentBookObject && setParentBookObject(objBookEmpty)
            }
        }
        
        const hasValidUserProps = !isNullUndefined(userProps) && userProps.partyId !== null && userProps.partyMemberId !== null;

        if (hasValidUserProps && ((qsBookId !== null && bookId === null) || fireGet === true)) {
            getData()
        }
    }, [qsBookId, bookId, setSuccessful, setMessage, setBookItem, setParentBookObject, fireGet,  userProps]);
}

const useGetHomeStadistic = (startDate, endDate, homeStadistic, setHomeStadistic, statusFilter, forceSearch, setForceSearch) => {    
    useEffect(()=> {
        const getData = async () => {
            try {
                const statusFilterValue = statusFilter === "0" || statusFilter === 0 ? null : statusFilter;

                let serviceResponse = await getHomeStadistic(startDate, endDate, statusFilterValue);
                const response = serviceResponse.data;
                if (response.succeeded) {
                    setHomeStadistic(prevState => ({
                        ...prevState,
                        fireUpdate: true,
                        data: response.data,
                    })) 
                    setForceSearch && setForceSearch(false)
                }
                else {
                    setHomeStadistic(prevState => ({
                        ...prevState,
                        fireUpdate: true,
                        data: [],
                    })) 
                    setForceSearch && setForceSearch(false)
                }
            }
            catch (error) {
                setHomeStadistic(prevState => ({
                    ...prevState,
                    fireUpdate: true,
                    data: [],
                })) 
                setForceSearch && setForceSearch(false)
            }
        }
        
        if (homeStadistic.data === null && forceSearch === true) {
            getData()
        }
    }, [homeStadistic, startDate, endDate, setHomeStadistic, statusFilter, forceSearch]);
}

export {
    useGetUsersByBookId,
    useGetBookById,
    useGetHomeStadistic,
}